__turbopack_context__.v({
  "placeHolderShimmer": "index-module-scss-module__b-rGjW__placeHolderShimmer",
  "spinner": "index-module-scss-module__b-rGjW__spinner",
});
